/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AkitaRemoteConfigQuery } from '@app/akita/api/remote-config/state/remote-config.query';

@Injectable({
  providedIn: 'root',
})
export class TranslateColorService {
  constructor(
    private readonly translateService: TranslocoService,
    private readonly akitaRemoteConfigQuery: AkitaRemoteConfigQuery
  ) {}

  public transform(label?: string): string {
    const lang = this.translateService.getActiveLang();
    return this.akitaRemoteConfigQuery.findColorTranslation(label || '', lang);
  }
}

@Pipe({
  name: 'translateColor',
  standalone: true,
})
export class TranslateColorPipe implements PipeTransform {
  constructor(private readonly translateColorService: TranslateColorService) {}

  /**
   * Gets a formatted string with the amount
   * @param {label} color label
   * @returns {String} the translated color label to the current locale.
   */
  public transform(label?: string): string {
    return this.translateColorService.transform(label);
  }
}
